<template>
    <div class="footPage">
        <div class="youqing flex flex-direction">
            <div class="flex align-center">
                <span>友情链接:</span>
                <a href="https://www.bjhdedu.cn/" >海淀教育网</a>
                <a href="https://www.ncsti.gov.cn/kjdt/scyq/zgckxc/index.html" >中关村科学城</a>
            </div>
            <div class="flex align-center margin-top-xs">
                <a href="https://kw.beijing.gov.cn/index.html" >北京市科委、中关村管委会</a>
                <a href="https://xwpx.eduyun.cn/" >全国校外培训监管与服务综合平台</a>
            </div>
        </div>
        <div class="foot-tex mt">主办：北京正信民生科技创新服务联盟</div>
        <div class="foot-tex">技术支持：北京易魔方科技集团有限公司</div>
        <div class="foot-tex">
            <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备18050245号-5</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102007553">京公网安备11010102007553号</a>
        </div>
    </div>
</template>
<script>
export default {
    name: "footPage",
    data() {
        return {}
    },
    components: {},
    created() {

    },
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.footPage {
    width: 100%;
    background-image: linear-gradient(0deg,
        #4fa5ff 0%,
        #0e7eff 100%);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 6vw 4vw;

    .foot-tex {
        font-size: 3vw;
        color: #ffffff;
        line-height: 6vw;
        &.mt {
            margin-top: 7vw;
        }

        a {
            color: #ffffff;
            font-size: 3vw;
            margin-right: 5vw;
        }
    }

    .youqing {
        width: 100%;
        display: flex;

        a {
            font-size: 3vw;
            color: #ffffff;
            margin-right: 5vw;
        }

        span {
            font-size: 3vw;
            color: #ffffff;
        }
    }
}
</style>


